import api from './api';

// Mock implementation for demo purposes
// In a real app, this would connect to your backend API
export const authService = {
    async login(userType, email, password) {
        // Simulate API call delay
        await new Promise(resolve => setTimeout(resolve, 500));

        // Always return successful login regardless of credentials
        // Mock successful login with fake data based on user type
        const mockUsers = {
            vendedor: {
                id: 1,
                name: 'Carlos Santos',
                email: email || 'carlos@exemplo.com',
                role: 'vendedor',
                permissions: ['sales', 'inventory', 'reports']
            },
            cliente: {
                id: 101,
                name: 'João Carlos Silva',
                email: email || 'joao@exemplo.com',
                role: 'cliente',
                properties: [
                    { id: 45, name: 'Torre Sul - 1004', type: 'Fração', week: 14 }
                ]
            }
        };

        // Return mock user data for the selected type
        return {
            user: mockUsers[userType],
            token: 'mock-jwt-token-' + userType
        };
    },

    async logout() {
        // Simulate API call delay
        await new Promise(resolve => setTimeout(resolve, 300));
        return { success: true };
    },

    async validateToken(token) {
        // Simulate API call delay
        await new Promise(resolve => setTimeout(resolve, 300));

        // Mock token validation
        if (token.includes('vendedor')) {
            return {
                id: 1,
                name: 'Carlos Santos',
                email: 'carlos@exemplo.com',
                role: 'vendedor',
                permissions: ['sales', 'inventory', 'reports'],
                initials: 'CS'
            };
        } else if (token.includes('cliente')) {
            return {
                id: 101,
                name: 'João Carlos Silva',
                email: 'joao@exemplo.com',
                role: 'cliente',
                properties: [
                    { id: 45, name: 'Torre Sul - 1004', type: 'Fração', week: 14 }
                ],
                initials: 'JS'
            };
        }

        throw new Error('Token inválido');
    }
};

export default authService;